// src/com/trans_plan_launch/TransPlanLaunchItem.js
import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { Button, IconButton, Tooltip, Chip } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox'; // zipgiBool true
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'; // zipgiBool false
import StorefrontIcon from '@mui/icons-material/Storefront'; // 동적표시용.
import LocationOnIcon from '@mui/icons-material/LocationOn'; // 지도로 이동
import LocationOffIcon from '@mui/icons-material/LocationOff'; // 위치정보 없음
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'; // save
import ClearIcon from '@mui/icons-material/Clear'; // delete
import SearchIcon from '@mui/icons-material/Search'; // search vehicle
import LocalShippingIcon from '@mui/icons-material/LocalShipping'; // set vehicle
import MessageIcon from '@mui/icons-material/Message'; // message
import { useMutation, useReactiveVar } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { useConfirmDialog } from '../../common/AppConfirmDialog';
import { AppMenuUrl, AppObject, AppStyle, AppWord, InputType, MapValue, TopCode } from '../../value/AppConst';
import { useAlertSetter, useAuthorizationCheck } from '../../api/app-hook';
import {
    authTableTreeRepo, menuRequestRepo, menuTreeRepo,
    transPlanTsrListParamRepo, vehInfoListOfDcRepo, waveListRepo
} from '../../value/AppModel';
import ValueMisc from '../../value/ValueMisc';
import IsValid from '../../value/IsValid';
import InputUtil from '../../value/InputUtil';
import VzmSelector from '../../common/VzmSelector';
import Time24Picker from '../../common/Time24Picker';
import VzmTextField from '../../common/VzmTextField';
import VzmIntField from '../../common/VzmIntField';
import AutoTextField from '../../common/AutoTextField';
import { WhiteChip } from '../../common/VzmStyled';
import { TransPlanLaunchDictionary } from './TransPlanLaunchDict';
import VehInfoSelectDialog from '../veh_info/VehInfoSelectDialog';
import { SEND_TRANS_PLAN_GUIDE_SMS } from '../trans_plan/TransPlanGql';

const BackgroundColor = '#f8f8f8';
const HochaContainer = styled(Box)({
    display: 'inline-flex',
    width: 240,
    flexDirection: 'column',
    padding: '1px 5px 3px 5px',
    transition: 'all 0.3s ease',
    fontSize: '0.8rem',
    backgroundColor: BackgroundColor, border: AppStyle.BorderEEE, borderRadius: 2,
    margin: '5px 1px 1px 1px',
    boxSizing: 'border-box',
});

const HochaTitleBox = styled(Box)({
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 5, minHeight: 36
});

const ZipgiMark = styled('span')({
    fontSize: '0.75rem', color: 'white', backgroundColor: AppStyle.PrimaryRGB,
    padding: 1, borderRadius:2, marginRight: 1,
})

// 상위 배차구분,차종,운송사 등 입력 컴포넌트들을 전체 포함하는 컴포넌트.
const PlanBox = styled(Box)({
    padding: '12px 5px 5px 5px',
    backgroundColor: 'white', borderRadius: 5,
    borderWidth: 1, borderStyle: 'solid', // borderColor: AppStyle.BorderLightGray,
});

const BindBox = styled(Box)({
    padding: '5px', border: AppStyle.BorderCCC, borderRadius: 5, backgroundColor: 'white',
    marginTop: 2, marginBottom: 2,
    display: 'flex', alignItems: 'center',
});

const BindInfoBox = styled(Box)({flexGrow: 1});

const TruckBoxActive = '#e0fffe';
const TruckBoxInactive = '#f0f0f0';
const TruckPickingBox = styled(Box)({
    padding: 5, // backgroundColor: '#e0fffe',
    borderRadius: 5,
    marginTop: 2,
});

const BlockHeight = 37;
const VzmLabelBlock = styled(Box)({
    padding: '5px 0px 5px 0px', height: BlockHeight, boxSizing: 'border-box',
    display: 'flex', alignItems: 'center', justifyContent: 'end',
});
const PlanInputBlock = styled(Box)({
    padding: '2px 0px 1px 0px', height: BlockHeight, boxSizing: 'border-box',
    display: 'flex', alignItems: 'center',
});

const UnderlinedLabel = styled(Box)({
    padding: '5px 0px 5px 14px', boxSizing: 'border-box', //backgroundColor: 'white',
    borderBottom: AppStyle.BorderCCC, display: 'flex', alignItems: 'center',
    flexGrow: 1,
});
// store popover
const StoreLineBox = styled(Box)({display: 'flex', alignItems: 'center', padding: 5});

const InputMap = TransPlanLaunchDictionary.inputMap;
// const defaultInputData = InputUtil.defaultValuesFromInputMap(InputMap);

const makeDefaultData = (baseData) => {
    const data = {};
    Object.keys(InputMap).forEach((key) => {
        const dict = InputMap[key];
        if((dict.type===InputType.number || dict.type===InputType.int) && dict.required) {
            data[key] = dict.default || 0;
        }
    });
    Object.assign(data, baseData);
    return data;
};

const getHhmm = (value) => {
    return value ? value.substring(11,16).replace(/\D/, '') : null
};

const getVehicleObject = (vehInfoList, comId, vehPlates) => {
    if(vehPlates) {
        for(const veh of vehInfoList) {
            if(veh.vehPlates === vehPlates && veh.comId === comId) return veh;
        }
    }
    return null;
};


const EmptyVehInfoList = [{vehPlates:AppWord.ChooseKorean, driverName:'', driverMobile:''}];
/**
 * 수동 개별 배차등록.
 * 1. 배차 자체의 생성. (동적 선택 포함) - 과거 PR_TRANS_PLAN_NEW_REG (사실 new, edit 둘다 포함함)
 * 2. 차량을 선택하여 등록 - 과거 PR_TRANS_PLAN_EDIT_REG
 * 3. 차량에 메시지 전송.
 * 4. 배차 삭제 - 과거 PR_TRANS_PLAN_DEL
 * @param {*} param0 
 */
export default function TransPlanLaunchItem({
    hocha, // 호차
    baseData, // {dcCd, arriveId, storeId, planDate}
    item,
    vehTypeList,
    comInfoList,
    lastDockno,
    onRequestSave, // {param, isEdit}
    onRequestRemove,
    onRequestSetTruck,
    onRequestOffTruck,
    onRequestReload,
    onRequestPopupBindManager,
    holdMutation
}) {
    const menuTree = useReactiveVar(menuTreeRepo);
    const [input, setInput] = useState({...AppObject.emptyInputData});
    const [isEdit, setIsEdit] = useState(false);
    const [inputSetVehicle, setInputSetVehicle] = useState({...AppObject.emptyInputData});
    const [storesBound, setStoresBound] = useState(false);
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const waveList = useReactiveVar(waveListRepo);
    const vehInfoListOfDcData = useReactiveVar(vehInfoListOfDcRepo);
    const [vehInfoList, setVehInfoList] = useState(EmptyVehInfoList);
    const [vehicleSelected, setVehicleSelected] = useState({}); //지도이동 체크를 위해서.
    const [openVehicleSelectBox, setOpenVehicleSelectBox] = useState(false);
    const openConfirmDialog = useConfirmDialog();
    const addAlert = useAlertSetter();
    const { enqueueSnackbar } = useSnackbar();
    const checkAuth = useAuthorizationCheck();
    const planDateMidNight = useMemo(() => baseData ? new Date(baseData.planDate + AppWord.HMS_TAIL) : null, [baseData]);
    const [sendGuideSms, responseSendMsg] = useMutation( SEND_TRANS_PLAN_GUIDE_SMS, {
        onCompleted: (data, option) => onCompleteSendGuideSms(data, option),
        onError: (error) => addAlert({title: "안내 문자 전송 오류", message: [error.message]})
    });

    useEffect(() => {
        if(baseData) {
            const inputSet = {...AppObject.emptyInputData};
            let editing = false;
            if(item) {
                inputSet.data = {...item};
                editing = true;

                setInputSetVehicle({
                    data: {vehPlates: item.vehPlates},
                    changed: false,
                    error: {},
                    hasError: false
                });
                setStoresBound(item.bindStores && item.bindStores.length > 0);
            }
            else {
                inputSet.data = makeDefaultData(baseData);
                inputSet.data.hocha = hocha;
                inputSet.data.dockno = lastDockno || baseData.basicDockno;
                inputSet.data.shprReqTime = baseData.planDate + AppWord.HMS_TAIL;
                inputSet.data.dptrReqTime = baseData.planDate + AppWord.HMS_TAIL;
                inputSet.data.arrReqTime = baseData.planDate + AppWord.HMS_TAIL;
                inputSet.data.zipgiBool = false;

                editing = false;
                Object.assign(inputSet.data, baseData);
                setInputSetVehicle({...AppObject.emptyInputData});
                setStoresBound(false);
            }
            setInput(inputSet);
            setIsEdit(editing);
        }
        else {
            setInput({...AppObject.emptyInputData});
            setInputSetVehicle({...AppObject.emptyInputData});
            setIsEdit(false);
        }
    }, [hocha, item, baseData, lastDockno]);

    useEffect(() => {
        if(item && input.data.comId && vehInfoListOfDcData.records[input.data.comId]) {
            setVehInfoList(vehInfoListOfDcData.records[input.data.comId]);
        }
        else setVehInfoList(EmptyVehInfoList);
    }, [vehInfoListOfDcData, input.data.comId, item]);

    useEffect(() => {
        let veh = {};
        if(inputSetVehicle.data.vehPlates) {
            const vehFound = getVehicleObject(vehInfoList, input.data.comId, inputSetVehicle.data.vehPlates);
            if(vehFound) veh = vehFound;
        }
        setVehicleSelected(veh);
    }, [inputSetVehicle, input, vehInfoList]);

    /* ################### GQL callback ################### */
    const onCompleteSendGuideSms = (data, option) => {
        if(data.transPlanSendGuideSms.ok) {
            enqueueSnackbar('안내 문자 전송 완료', {variant: 'success', autoHideDuration: 1500});
        }
        else addAlert({title:"안내 문자 전송 오류", message:[data.transPlanSendGuideSms.message]});
    };
    
    /* ################### Event Handlers ################### */
    const onChangeValue = (id, value, error) => {
        const newInput = InputUtil.reflectData(input, id, value, error, InputMap, isEdit);
        setInput(newInput);
    };

    const onChangeSelect = (id, value) => {
        onChangeValue(id, value === AppWord.ChooseValue ? undefined : value, false);
    };

    // 접안시간은 그냥 이것 써도 됨.
    const onChangeTime24 = (id, value, error) => {
        if(!Boolean(value) || value.length !== 4) {
            onChangeValue(id, value, error);
            return;
        }
        const oldValue = input.data[id];
        const hh = value.substring(0, 2);
        const mm = value.substring(2, 4);
        if(oldValue) {
            const hhmm = oldValue.substring(11, 16).replace(/\D/, '');
            if(hhmm !== value) {
                onChangeValue(
                    id,
                    oldValue.substring(0, 11) + hh + ":" + mm + ':00',
                    error
                );
            }
        }
        else onChangeValue(id, baseData.planDate + ' ' + hh + ":" + mm + ':00', error);
    };

    // 출발요청시간
    const onChangeDptrReqTime24 = (id, value, error) => {
        const arriveInfo = baseData.arriveInfo;
        // 1. 출발요청시간
        const dptrReqTime = input.data.dptrReqTime ? new Date(input.data.dptrReqTime) : planDateMidNight;
        const dptrReqHms = ValueMisc.parseHourMinSec(value);
        dptrReqTime.setHours(dptrReqHms.hour, dptrReqHms.minute);

        // 출발요청기준값 copy planDateMidNight
        const startRequestedToBe = new Date(planDateMidNight);
        const startReqHms = ValueMisc.parseHourMinSec(arriveInfo.startReqTimeToday);
        startRequestedToBe.setHours(startReqHms.hour, startReqHms.minute);

        // 2. 도착요청시간을 만들어 가기.
        const arrReqTime = new Date(planDateMidNight);

        if(arriveInfo.startReqTimeToday && dptrReqTime >= startRequestedToBe) {
            arrReqTime.setDate(arrReqTime.getDate() + 1);

            if(IsValid.string(arriveInfo.arriveReqTimeNext,4,10)) {
                const hms = ValueMisc.parseHourMinSec(arriveInfo.arriveReqTimeNext);
                arrReqTime.setHours(hms.hour, hms.minute);
            }
            else if(IsValid.string(arriveInfo.firstShipTime,4,10)) {
                const hms = ValueMisc.parseHourMinSec(arriveInfo.firstShipTime);
                arrReqTime.setHours(hms.hour, hms.minute);
            }
            else {
                arrReqTime.setHours( dptrReqTime.getHours(), dptrReqTime.getMinutes() + 240 );
            }
        }
        else if(IsValid.string(arriveInfo.basicExpectRunTime, 4, 10)) {
            const hms = ValueMisc.parseHourMinSec(arriveInfo.basicExpectRunTime);
            arrReqTime.setHours(
                dptrReqTime.getHours(),
                dptrReqTime.getMinutes() + hms.hour * 60 + hms.minute
            )
        }
        else arrReqTime.setHours( dptrReqTime.getHours(), dptrReqTime.getMinutes() + 240 );

        // 날짜 조정.ValueMisc.isSameDate(arrReqTime, dptrReqTime)
        if(arrReqTime.getDate() === dptrReqTime.getDate()) {
            if(arrReqTime <= dptrReqTime) arrReqTime.setDate(dptrReqTime.getDate() + 1);
        }

        // 3. 접안시간 만들어 가기.
        const shprReqTime = new Date(dptrReqTime);
        shprReqTime.setMinutes(dptrReqTime.getMinutes() - 50);

        const newInput = InputUtil.reflectData(input, id, ValueMisc.getYmdHms(dptrReqTime), error, InputMap, isEdit);
        const newInput2 = InputUtil.reflectData(newInput, InputMap.shprReqTime.id, ValueMisc.getYmdHms(shprReqTime), false, InputMap, isEdit);
        const newInput3 = InputUtil.reflectData(newInput2, InputMap.arrReqTime.id, ValueMisc.getYmdHms(arrReqTime), false, InputMap, isEdit);

        setInput(newInput3);
    };

    // 도착요청시간
    const onChangeArrReqTime24 = (id, value, error) => {
        const arriveInfo = baseData.arriveInfo;
        // 일단 출발요청시간 확인.
        const dptrReqTime = input.data.dptrReqTime ? new Date(input.data.dptrReqTime) : planDateMidNight;

        // 출발요청기준값 copy planDateMidNight
        const startRequestedToBe = new Date(planDateMidNight);
        const startReqHms = ValueMisc.parseHourMinSec(arriveInfo.startReqTimeToday);
        startRequestedToBe.setHours(startReqHms.hour, startReqHms.minute);

        // 도착요청시간을 만들어 가기.
        const arrReqTime = new Date(planDateMidNight);
        const hms = ValueMisc.parseHourMinSec(value);
        arrReqTime.setHours(hms.hour, hms.minute);

        // 필요하면 날짜 조정: 출발하라는 시각이 출발요청시간기준보다 늦으면 도착할 시각(arrReqTime)은 다음날로 설정
        if(arriveInfo.startReqTimeToday && dptrReqTime >= startRequestedToBe) {
            arrReqTime.setDate(dptrReqTime.getDate() + 1);
        }
        else if(arrReqTime <= dptrReqTime) arrReqTime.setDate(dptrReqTime.getDate() + 1);

        onChangeValue(id, ValueMisc.getYmdHms(arrReqTime), error);
    };
    
    const onVehicleSelected = (id, value) => {
        const newData = {...inputSetVehicle};
        if(newData.data.vehPlates !== value) {
            newData.data.vehPlates = value===AppWord.ChooseKorean ? undefined : value;
            if(item) {
                // 기존 차량과 비교해서 changed 여부를 결정.
                // 같으면 원래 차량으로 다시 돌아간 것이므로.
                const vehFound = getVehicleObject(vehInfoList, input.data.comId, value);
                newData.changed = item.vehPlates !== value || item.comId !== vehFound.comId;
            }
            else newData.changed = true;
            setInputSetVehicle(newData);
        }
    };
    
    const onChangeVehicleInputText = (e, value, reason) => {
        if(reason === 'clear' || (reason === 'input' && value === '')) {
            // 기존 값을 다시 넣어줘야 하는지 고민.
            const newData = {...inputSetVehicle};
            newData.data.vehPlates = undefined;
            newData.changed = true;
            setInputSetVehicle(newData);
        }
    };

    const onClickGoToMap = () => {
        if(vehicleSelected.vehPlates && vehicleSelected.gpsTime) {
            const mapUrl = ValueMisc.makeMapUrl({
                job: MapValue.MapInitEvent.traceVehicle,
                vehInfoSeqToTrace:vehicleSelected.vehInfoSeq,
                vehPlates:vehicleSelected.vehPlates,
                vehAlias:vehicleSelected.vehPlates
            });
            window.open(mapUrl, AppWord.MAP_WINDOW_NAME);
        }
    };

    const onClickSavePlan = () => {
        const param = InputUtil.getDataToSubmit(input.data, InputMap, isEdit);
        // 왜 숫자로 변환되어 오는지 모르겠음. 강제로 문자열로 변환.
        if(param.dockno !== null && param.dockno !== undefined)
            param.dockno = `${param.dockno}`.trim();
        onRequestSave(param, isEdit);
    };

    const onClickRemovePlan = async () => {
        if(item) {
            const confirm =  await openConfirmDialog({
                title: "운송요청 삭제",
                content: [
                    `${item.hocha}호차 운송요청를 삭제합니다.`,
                    '삭제 후 복구할 수 없습니다. 계속하시겠습니까?'
                ]
            });

            if(confirm) {
                onRequestRemove(item);
            }
        }
    };

    const onClickToMoveToTSR = () => {
        if(item) {
            const menuSet = ValueMisc.findMenu(AppMenuUrl.TSR, menuTree);
            if(!menuSet.menu) {
                addAlert({
                    title: 'TSR 화면 이동',
                    message: ['TSR 화면이 없습니다. 관리자에게 문의해 주세요.'],
                });
                return;
            }
            transPlanTsrListParamRepo({
                dcCd: item.dcCd,
                storeId: item.storeId,
                planDate: item.planDate,
            });
            menuRequestRepo(menuSet);
        }
    };

    const onClickSetVehicle = () => {
        if(item && item.planId && vehicleSelected.vehPlates && input.data.comId) {
            const param = {
                planId: item.planId,
                vehPlates: vehicleSelected.vehPlates,
                comId: input.data.comId,
            };
            onRequestSetTruck(param);
        }
    };

    const onClickRemoveVehicle = async () => {
        if(item && item.vehPlates) {
            const confirm =  await openConfirmDialog({
                title: "배차 취소",
                content: [
                    `${item.hocha}호차의 ${item.vehPlates} 차량 배차를 취소합니다.`,
                    '계속하시겠습니까?'
                ]
            });

            if(confirm) {
                onRequestOffTruck(item.planId);
            }
        }
    };

    const onClickSendGuideSms = async () => {
        if(item && item.vehPlates && item.driverMobile && item.reqStateFlag !== TopCode.ReqStateFlag.TsrIssued) {
            const confirm =  await openConfirmDialog({
                title: "안내 문자 전송",
                content: [
                    `${item.hocha}호차의 ${item.vehPlates} 차량에 안내 문자를 전송합니다.`,
                    '계속하시겠습니까?'
                ]
            });

            if(confirm) {
                sendGuideSms({variables: {planId: item.planId}});
            }
        }
    };

    /* const onCloseBindManager = (changed) => {
        setOpenBindManager(false);
        if(changed) {
            onRequestReload();
        }
    }; */

    const canAdd = checkAuth(authTableTree.tree.pr_trans_plan_add);
    const canEdit = checkAuth(authTableTree.tree.pr_trans_plan_edit);
    const canRemove = checkAuth(authTableTree.tree.pr_trans_plan_remove);
    const canSetVehicle = checkAuth(authTableTree.tree.pr_trans_plan_set_truck);
    const canRemoveVehicle = checkAuth(authTableTree.tree.pr_trans_plan_off_truck);
    const canSendSms = checkAuth(authTableTree.tree.pr_trans_plan_guide_sms);

    const renderMiscChip = () => {
        if(item) {
            if(item.reqStateFlag === TopCode.ReqStateFlag.TsrNotIssued) {
                return(
                    <Tooltip title={"TSR(미발행)로 이동"}>
                        <Chip
                            label="TSR미발행"
                            size={AppWord.SMALL}
                            onClick={onClickToMoveToTSR}
                            color={AppStyle.mui.warning}
                            style={{marginLeft: 5, fontSize:'0.7rem', fontWeight:'normal'}}
                        />
                    </Tooltip>
                );
            }
            if(item.reqStateFlag === TopCode.ReqStateFlag.TsrIssued) {
                return(
                    <Tooltip title={"TSR로 이동"}>
                        <Chip
                            label="TSR발행"
                            size={AppWord.SMALL}
                            onClick={onClickToMoveToTSR}
                            color={AppStyle.mui.success}
                            style={{marginLeft: 5, fontSize:'0.7rem', fontWeight:'normal'}}
                        />
                    </Tooltip>
                )
            }
        }
        return null;
    };

    const renderBindStores = () => {
        // 
        if(storesBound && item && item.bindStores && item.bindStores.length > 0) {
            const stores = item.bindStores;
            return (
                <Box style={{padding:1}}
                >
                    <Tooltip
                        title={
                            <Box>
                                {
                                    stores.map((store) => {
                                        return (
                                            <StoreLineBox key={store.storeId}
                                                style={{fontSize:'0.9rem'}}
                                            >
                                                <StorefrontIcon
                                                    fontSize={AppWord.SMALL}
                                                    color={
                                                        store.storeId === item.storeId
                                                        ? AppStyle.mui.inherit
                                                        : AppStyle.mui.warning
                                                    }
                                                />
                                                <Box style={{paddingLeft: 5}}>
                                                    [{store.storeId}] {store.storeName}
                                                </Box>
                                            </StoreLineBox>
                                        )
                                    })
                                }
                            </Box>
                        }
                    >
                        <Box style={{overflow: 'hidden', textOverflow: 'ellipsis'}}>
                            {
                                stores.map((store)=>{
                                    return (
                                        <React.Fragment key={store.storeId}> ..
                                        <StorefrontIcon fontSize={AppWord.SMALL}
                                            color={
                                                store.storeId === item.storeId
                                                ? AppStyle.mui.inherit
                                                : AppStyle.mui.warning
                                            }
                                        />
                                        </React.Fragment>
                                    )
                                })
                            }
                        </Box>
                    </Tooltip>
                </Box>
            );
        }
        return (
            <Box style={{padding:5, display:'flex', alignItems:'center'}}>
                <StorefrontIcon
                    fontSize={AppWord.SMALL} color={AppStyle.mui.disabled}
                    style={{marginRight: 5}}
                />
                {item ? '동적 점포 없음' : <span style={{color:'#ccc'}}>*********</span>}
            </Box>
        )
    };

    if(!baseData) {
        return(
            <HochaContainer style={{maxWidth:90, textAlign:'right'}}>
                <HochaTitleBox>
                    <IconButton
                        size={AppWord.SMALL}
                        color={AppStyle.mui.inherit}
                        disabled={true}
                    >
                        <CheckBoxOutlineBlankIcon />
                    </IconButton>
                    호차
                </HochaTitleBox>
                <PlanBox style={{borderColor: BackgroundColor}}>
                    <VzmLabelBlock>배차구분</VzmLabelBlock>
                    <VzmLabelBlock>차종</VzmLabelBlock>
                    <VzmLabelBlock>운송사</VzmLabelBlock>
                    <VzmLabelBlock >접안시간</VzmLabelBlock>
                    <VzmLabelBlock>출발요청시간</VzmLabelBlock>
                    <VzmLabelBlock>도착요청시간</VzmLabelBlock>
                    <VzmLabelBlock>Dock No.</VzmLabelBlock>
                    <VzmLabelBlock>추가운임</VzmLabelBlock>
                    <VzmLabelBlock>비고</VzmLabelBlock>
                    <Box height={30}>&nbsp;</Box>
                </PlanBox>
                <Box height={47}>&nbsp;</Box>
                <TruckPickingBox style={{paddingBottom:41, backgroundColor: TruckBoxActive}}>
                    <VzmLabelBlock height={46}>차량</VzmLabelBlock>
                    <VzmLabelBlock>기사</VzmLabelBlock>
                    <VzmLabelBlock>연락처</VzmLabelBlock>
                </TruckPickingBox>
            </HochaContainer>
        );
    }

    const loadingAny = responseSendMsg.loading;
    return(
        <HochaContainer>
            <HochaTitleBox>
                <Tooltip title="집기">
                    <IconButton
                        size={AppWord.SMALL}
                        color={input.data.zipgiBool ? AppStyle.mui.error : AppStyle.mui.inherit}
                        onClick={()=>onChangeValue(InputMap.zipgiBool.id, !input.data.zipgiBool, false)}
                    >
                        {input.data.zipgiBool ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                    </IconButton>
                </Tooltip>
                {
                    input.data.zipgiBool
                    && <ZipgiMark>집</ZipgiMark>
                }
                <WhiteChip
                    label={hocha+"호차"}
                    size={AppWord.SMALL}
                    style={{color: item || input.changed ? AppStyle.PrimaryRGB : '#777'}}
                />
                {renderMiscChip()}
                {
                    storesBound &&
                    <span style={{
                        fontSize:'0.8rem', backgroundColor:'red', marginLeft: 2,
                        padding: '3px 5px 3px 5px',
                        borderRadius: 15, color: 'white'
                    }}>동</span>
                }
            </HochaTitleBox>
            <PlanBox
                style={{
                    borderColor: isEdit ? AppStyle.PrimaryRGB : '#ccc'
                }}
            >
                <PlanInputBlock>
                    <VzmSelector
                        dict={InputMap.transTypeCd}
                        value={input.data.transTypeCd || AppWord.ChooseValue}
                        onChange={onChangeSelect}
                        list={waveList}
                        fullWidth={true}
                        variant={AppStyle.mui.standard}
                        hideLabel={true}
                    />
                </PlanInputBlock>
                <PlanInputBlock>
                    <VzmSelector
                        dict={InputMap.vehTypeId}
                        value={input.data.vehTypeId || AppWord.ChooseValue}
                        onChange={onChangeSelect}
                        list={vehTypeList}
                        fullWidth={true}
                        variant={AppStyle.mui.standard}
                        hideLabel={true}
                    />
                </PlanInputBlock>
                <PlanInputBlock>
                    <VzmSelector
                        dict={InputMap.comId}
                        value={input.data.comId || AppWord.ChooseValue}
                        onChange={onChangeSelect}
                        list={comInfoList}
                        fullWidth={true}
                        variant={AppStyle.mui.standard}
                        hideLabel={true}
                    />
                </PlanInputBlock>
                <PlanInputBlock>
                    <Time24Picker
                        dict={InputMap.shprReqTime}
                        value={getHhmm(input.data.shprReqTime)}
                        onChange={onChangeTime24}
                        hideLabel={true}
                        disableTextField={true}
                        variant={AppStyle.mui.standard}
                    />
                </PlanInputBlock>
                <PlanInputBlock>
                    <Time24Picker
                        dict={InputMap.dptrReqTime}
                        value={getHhmm(input.data.dptrReqTime)}
                        onChange={onChangeDptrReqTime24}
                        hideLabel={true}
                        disableTextField={true}
                        variant={AppStyle.mui.standard}
                    />
                </PlanInputBlock>
                <PlanInputBlock>
                    <Time24Picker
                        dict={InputMap.arrReqTime}
                        value={getHhmm(input.data.arrReqTime)}
                        onChange={onChangeArrReqTime24}
                        hideLabel={true}
                        variant={AppStyle.mui.standard}
                    />
                    <Chip
                        label={
                            input.data.arrReqTime !== input.data.dptrReqTime
                            &&
                            ValueMisc.isSameDate(input.data.arrReqTime, input.data.dptrReqTime)
                            ?
                            '당일'
                            :
                            '익일'
                        }
                        size={AppWord.SMALL}
                        color={
                            input.data.arrReqTime !== input.data.dptrReqTime
                            &&
                            ValueMisc.isSameDate(input.data.arrReqTime, input.data.dptrReqTime)
                            ?
                            AppStyle.mui.default : AppStyle.mui.success
                        }
                    />
                    
                </PlanInputBlock>
                <PlanInputBlock>
                    <VzmTextField
                        dict={InputMap.dockno}
                        value={input.data.dockno}
                        onChange={onChangeValue}
                        hideLabel={true}
                        fullWidth={true}
                        variant={AppStyle.mui.standard}
                        inputProps={{style:{fontSize:'0.85rem'}}}
                    />
                </PlanInputBlock>
                <PlanInputBlock>
                    <VzmIntField
                        dict={InputMap.addCharge}
                        value={input.data.addCharge}
                        onChange={onChangeValue}
                        hideLabel={true}
                        fullWidth={true}
                        variant={AppStyle.mui.standard}
                        inputProps={{style:{fontSize:'0.85rem'}}}
                    />
                </PlanInputBlock>
                <PlanInputBlock>
                    <VzmTextField
                        dict={InputMap.note}
                        value={input.data.note}
                        onChange={onChangeValue}
                        hideLabel={true}
                        fullWidth={true}
                        variant={AppStyle.mui.standard}
                        inputProps={{style:{fontSize:'0.85rem'}}}
                    />
                </PlanInputBlock>
                <Box style={{display:'flex'}}>
                    {
                        item
                        ?
                        <Button
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                            size={AppWord.SMALL}
                            style={{flexGrow:1, marginRight:2}}
                            startIcon={<CardGiftcardIcon />}
                            disabled={!input.changed || holdMutation || !canEdit}
                            onClick={onClickSavePlan}
                        >
                            수정
                        </Button>
                        :
                        <Button
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                            size={AppWord.SMALL}
                            style={{flexGrow:1, marginRight:2}}
                            startIcon={<CardGiftcardIcon />}
                            disabled={!input.changed || holdMutation || !canAdd}
                            onClick={onClickSavePlan}
                        >
                            추가
                        </Button>
                    }
                    <Button
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.warning}
                        size={AppWord.SMALL}
                        style={{flexGrow:1, marginLeft:2}}
                        startIcon={<ClearIcon />}
                        disabled={!Boolean(item) || holdMutation || !canRemove}
                        onClick={onClickRemovePlan}
                    >
                        삭제
                    </Button>
                </Box>
            </PlanBox>
            <BindBox>
                <BindInfoBox>
                    {renderBindStores()}
                </BindInfoBox>
                <Tooltip title="신규동적 생성 또는 기존동적 관리">
                    <span>
                        <Button
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.secondary}
                            size={AppWord.SMALL}
                            disabled={!Boolean(item) || holdMutation}
                            onClick={()=>onRequestPopupBindManager(item)}
                        >
                            동적
                        </Button>
                    </span>
                </Tooltip>
            </BindBox>
            <TruckPickingBox style={{backgroundColor: item ? TruckBoxActive : TruckBoxInactive}}>
                <PlanInputBlock>
                    <AutoTextField
                        dict={TransPlanLaunchDictionary.inputMapToSetVeh.vehPlates}
                        value={
                            item && inputSetVehicle.data.vehPlates && vehInfoList.length > 1
                            ? inputSetVehicle.data.vehPlates
                            : AppWord.ChooseKorean
                        }
                        onChange={onVehicleSelected}
                        onInputChange={onChangeVehicleInputText}
                        list={item ? vehInfoList : EmptyVehInfoList}
                        style={{minWidth:180}}
                        hideLabel={true}
                    />
                    <IconButton
                        color={AppStyle.mui.primary}
                        size={AppWord.SMALL}
                        disabled={!item || loadingAny}
                        onClick={()=>setOpenVehicleSelectBox(true)}
                    >
                        <SearchIcon />
                    </IconButton>
                </PlanInputBlock>
                <PlanInputBlock>
                    <UnderlinedLabel>
                        {
                            vehicleSelected.driverName ||
                            input.data.driverName ?
                            <span>
                                {
                                    vehicleSelected.driverName || input.data.driverName
                                }
                            </span>
                            :
                            <span style={{color:'#ccc'}}>[없음]</span>
                        }
                    </UnderlinedLabel>
                    {
                        vehicleSelected.vehPlates &&
                        <Tooltip title={vehicleSelected.gpsTime ? "지도로 이동" : "위치정보 없음"}>
                            <IconButton
                                size={AppWord.SMALL}
                                onClick={onClickGoToMap}
                                color={AppStyle.mui.secondary}
                            >
                                {
                                    vehicleSelected.gpsTime ?
                                    <LocationOnIcon fontSize='11pt' /> :
                                    <LocationOffIcon fontSize='11pt' />
                                }
                            </IconButton>
                        </Tooltip>
                    }
                </PlanInputBlock>
                <PlanInputBlock>
                    <UnderlinedLabel>
                        {
                            vehicleSelected.driverMobile ||
                            input.data.driverMobile ?
                            <span>{vehicleSelected.driverMobile || input.data.driverMobile}</span>
                            :
                            <span style={{color:'#ccc'}}>[없음]</span>
                        }
                    </UnderlinedLabel>
                    <Tooltip title="차량배정 취소">
                        <span>
                            <Button
                                variant={AppStyle.mui.contained}
                                color={AppStyle.mui.warning}
                                size={AppWord.SMALL}
                                disabled={!inputSetVehicle.data.vehPlates || !item || !item.vehPlates || !canRemoveVehicle || holdMutation}
                                onClick={onClickRemoveVehicle}
                            >
                                초기화
                            </Button>
                        </span>
                    </Tooltip>
                </PlanInputBlock>
                <Box style={{display:'flex', marginTop:5}}>
                    <Button
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.primary}
                        size={AppWord.SMALL}
                        style={{flexGrow:1, marginRight:2}}
                        startIcon={<LocalShippingIcon />}
                        disabled={!inputSetVehicle.changed || !item || !canSetVehicle || holdMutation}
                        onClick={onClickSetVehicle}
                    >
                        등록
                    </Button>
                    <Button
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        size={AppWord.SMALL}
                        style={{flexGrow:1, marginLeft:2}}
                        startIcon={<MessageIcon />}
                        disabled={
                            !Boolean(item) || !canSendSms || inputSetVehicle.changed
                            || !item.vehPlates || !item.driverMobile || item.reqStateFlag===TopCode.ReqStateFlag.TsrIssued
                            || responseSendMsg.loading || holdMutation}
                        onClick={onClickSendGuideSms}
                    >
                        메시지
                    </Button>
                </Box>
            </TruckPickingBox>
            <VehInfoSelectDialog
                open={openVehicleSelectBox}
                onClose={()=>setOpenVehicleSelectBox(false)}
                records={vehInfoList.slice(1)}
                onSelect={(veh) => {
                    onVehicleSelected(TransPlanLaunchDictionary.inputMapToSetVeh.vehPlates.id, veh.vehPlates);
                    setOpenVehicleSelectBox(false);
                }}
                defaultSearchText={inputSetVehicle.data.vehPlates}
            />
            {/* <TransPlanBindManager
                open={openBindManager}
                onClose={onCloseBindManager}
                defaultPlan={item}
            /> */}
        </HochaContainer>
    );
}
